import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgScottClass = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 52"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="m126.292 0-.001.459h.436l-1.602 1.41 1.113 14.415h7.372l2.406 3.617h14.332l.908 4.327h1.635l.414-1.371h2.354l1.03-11.487h4.885l1.49 11.924h1.498l1.188 4.945h1.085v1.978h9.886v.848h-.424v.424h-.988v-.424h-8.474v.565h-.27l.608 2.531h.086v-2.107h11.298v.848h-.283v.424h-.988v-.424h-4.943v1.56l2.885 4.678.85 1.289h19.143v-7.527h.706v7.527h2.542v-7.527h.706v7.527H200q0 5.816-3.363 11.114l-.078.122H10.051L.098 35.678q-.41-.687.888-.687c5.712 1.082 15.993 1.796 23.042 2.447l.842-11.3-1.443-1.542-.099-1.16 1.193-.793h2.288l1.006.792-.083 1.16-1.076 1.571 1.705 11.725.235.03c1.614.21 2.674.42 2.907.643q1.125 1.075 3.52 1.078l.663.03q16.398.721 48.741.28l.061-.041q.763-.531 3.42-2.796l-.535-1.67h-9.084v.424h-1.13v-1.13h10.168v-.424H75.041v.565h-1.13v-1.272h15.817v.895l.02-.006 2.264 1.784v3.556l.681-.012v-3.232a2.19 2.19 0 0 1 1.907-3.267h1.352q-.01-.105-.01-.212c0-1.21.98-2.19 2.189-2.19h7.202a2.18 2.18 0 0 1 1.38.489h5.496l8.188-11.512v-2.185l.688-1.432L122.24 1.87 121.085.46h.269V0zM93.824 37.564v2.242l1.94-.035 1.307-.024v-2.041h-2.47c-.274 0-.536-.05-.777-.142m6.92.142h-3.107v2.03l1.856-.035 1.25-.025zm2.39-.451c-.369.283-.83.45-1.331.45h-.07v1.951l.71-.014zm68.785-4.353h-4.095v1.26h4.095z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgScottClass
